import { webAssetsUrl } from '../../globals';
import { data } from './EnvSelector.data';
import { Env, Title, Wrapper } from './EnvSelector.style';

export type EnvSelectorProps = {
  env: string;
  onSelect: (env: string) => void;
};

export function EnvSelector(props: EnvSelectorProps) {
  function renderEnv(env: Json) {
    const style = {
      backgroundImage: `url(${webAssetsUrl}/env/env-${env.id}.png)`,
    };

    return (
      <Env style={style} key={env.id} className='env' onClick={() => props.onSelect(env.id)}>
        <Title className='title'>{env.name}</Title>
      </Env>
    );
  }

  function renderEnvs() {
    return data.map((env: Json) => renderEnv(env));
  }
  return (
    <Wrapper className='EnvSelector-wrapper' data-testid='EnvSelector-wrapper'>
      {renderEnvs()}
    </Wrapper>
  );
}

export default EnvSelector;
